import styled from "styled-components";

export const GorisontLine = styled.div`
    border: 1px solid #9ea7b0;
    margin-top: 20px;
`;
